import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { EnumeratedTypesRepositoryService, OrderManagerService, ValidationService } from 'reg-hub-common';
import { BusinessSearchCriteriaComponent } from '../business-search-criteria/business-search-criteria.component';
import { EnvironmentUrlService } from '../../services/environment-url/environment-url.service';

/**
 * Name or number search criteria for an international (Kyckr) business search. Each search targets the one
 * country chosen on the Order Info step, so there are no jurisdictions to pick.
 */
@Component({
  selector: 'app-international-business-search-criteria',
  templateUrl: '../business-search-criteria/business-search-criteria.component.html',
  styleUrls: ['../business-search-criteria/business-search-criteria.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class InternationalBusinessSearchCriteriaComponent extends BusinessSearchCriteriaComponent {
  protected override showJurisdictions: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    environmentUrl: EnvironmentUrlService,
    enumeratedTypesRepo: EnumeratedTypesRepositoryService,
    orderManager: OrderManagerService,
    validationService: ValidationService) {
    super(formBuilder, environmentUrl, enumeratedTypesRepo, orderManager, validationService);
  }

  // No search jurisdictions are loaded, so none are sent.
  protected override getOrderTypeJurisdictions(): void {
  }
}
